import { RequestAQuoteModal } from 'components/Modal/RequestAQuoteModal/RequestAQuoteModal';
import { useLoadRAQData } from 'hooks/useLoadRAQData';
import { IPageLoadData } from 'interfaces/analytics';
import {
  IRAQConfiguration,
  IRAQConfigurationOffers,
  VehicleSelectorType,
  IFormData,
} from 'interfaces/requestAQuote';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectZipcode } from 'redux/slices/zipcodeSlice';
import { generateParameters } from 'helpers/Url';

const Offers = (): JSX.Element => {
  const baseRaqEndpoint = '/platform/api/v1/request-a-quote';
  const offersPageloadObject = window.Acr.trackingObject;
  const [showRaqModal, setShowRaqModal] = useState(false);
  const [raqEndpoint, setRaqEndpoint] = useState(baseRaqEndpoint);
  const { status, data } = useLoadRAQData(raqEndpoint);
  const [formData, setFormData] = useState<IFormData>();
  const [pageLoadConfig, setPageLoadConfig] = useState<IPageLoadData>();

  const [raqConfiguration, setRaqConfiguration] = useState<
    IRAQConfiguration | undefined
  >();

  const zipcode = useSelector(selectZipcode);
  useEffect(() => {
    window.addEventListener('react-raq-open', (event) => {
      const eventDetail = (event as CustomEvent).detail;
      setShowRaqModal(true);
      const { modelId, offers } = eventDetail;
      if (offers.length > 0) {
        setRaqConfiguration({
          ...eventDetail,
          variant: VehicleSelectorType.offers,
        } as IRAQConfigurationOffers);
        const newRaqEndpoint = `${baseRaqEndpoint}${generateParameters({
          modelId,
          fullTaxonomy: 'false',
          zipcode,
        })}`;

        setRaqEndpoint(newRaqEndpoint);
      } else {
        setRaqConfiguration(undefined);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const confirmationPageLoadConfig: IPageLoadData = {
    ...pageLoadConfig,
    modelSeries: pageLoadConfig?.modelSeries || '',
    modelYear: pageLoadConfig?.modelYear || '',
    referrer_type: 'empty',
    pageName: `${offersPageloadObject?.Page?.page_name}:raq modal success`,
    subSection3: 'raq modal success',
    user: {
      first_name: formData?.['first-name'],
      last_name: formData?.['last-name'],
      email: formData?.email,
      phone_number: formData?.phone,
      zip_code: formData?.['raq-zipcode'],
      marketing_optin: 'opt-in',
    },
  };

  useEffect(() => {
    if (data?.vehicleData && showRaqModal) {
      const { modelSeries, modelYear } = data?.vehicleData;

      const newPageloadConfig = {
        pageName: `${offersPageloadObject?.Page?.page_name}:raq modal`,
        hideModelFromPageName: true,
        modelSeries: modelSeries,
        modelYear: modelYear.toString(),
        subSection: offersPageloadObject?.Page?.sub_section,
        subSection2: modelSeries,
        subSection3: 'raq modal',
      };
      setPageLoadConfig(newPageloadConfig);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, data, showRaqModal]);
  return (
    <>
      {showRaqModal && (
        <RequestAQuoteModal
          closeFunction={() => {
            setShowRaqModal(false);
          }}
          isOpen={showRaqModal}
          configuration={raqConfiguration}
          raqTitle="offersTitle"
          raqDescription="offersDescription"
          source={'offers'}
          pageLoadConfig={pageLoadConfig}
          confirmationPageLoadConfig={confirmationPageLoadConfig}
          setFormData={setFormData}
        />
      )}
    </>
  );
};

export default Offers;
